import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import MaterialRequirement from 'components/maintenance/materialRequirement/materialRequirement';

const Mrf = ({
  match,
  location,
  fetchSubCategoryType,
  subCategoryType,
  fetchCategory,
  categoryType,
  // createMrfForMaintenance,
  fetchCategoryList,
  typeCategoryList,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [successModal, setSuccessModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFiled, setIsFiled] = useState(false);
  const [material, setMaterial] = useState();
  useEffect(() => {
    if (match.params.id)
      (async () => {
        setIsLoading(true);
        await fetchCategoryList(1);
        setIsLoading(false);
      })();
  }, [fetchCategoryList]);

  // const mrfForMaintenance = async () => {
  //   let checkData = material.map((obj) =>
  //     Object.values(obj).every((x) => x !== null && x !== '')
  //   );
  //   if (checkData.includes(false)) {
  //     setIsFiled(true);
  //     return false;
  //   }
  //   if (material && material.length) {
  //     const materialUpdate = material.filter((obj) => delete obj.category_id);
  //     setMaterial(materialUpdate);
  //   }

  //   const data = {
  //     site_id: match.params.siteId,
  //     ticket_id: match.params.id,
  //     type: match.params.type,
  //     mat_data: material,
  //   };
  //   if (data.site_id !== '') {
  //     const res = await createMrfForMaintenance(data);
  //     if (res === true) {
  //       setIsFiled(false);
  //       setSuccessModal(true);
  //     }
  //   } else {
  //     setIsFiled(true);
  //   }
  // };

  // const headerBtns = () => {
  //   return (
  //     <Fragment>
  //       <Link
  //         to={`#`}
  //         onClick={() => mrfForMaintenance()}
  //         className="btn btn-primary"
  //       >
  //         <img src={Images?.ArrowRight} alt=""></img>
  //         {localization.submit}
  //       </Link>
  //     </Fragment>
  //   );
  // };

  return (
    <Layout
      title={localization.createMRF}
      // Buttons={headerBtns}
      isLoading={isLoading}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      linkUrl={`${baseUrl}/tickets/view-details/${match?.params?.id}`}
    >
      <MaterialRequirement
        data={typeCategoryList}
        getMaterial={subCategoryType}
        getMateriaById={fetchSubCategoryType}
        handleValue={(val) => {
          setMaterial(val);
        }}
      />

      <ModalPop
        title={localization.conf}
        show={successModal}
        handleModalHide={() => setSuccessModal(false)}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.saveSuccessfully}</h5>
          <Link
            to={
              match.params.type === 'pm'
                ? `/dashboard/tickets/view-details/${match.params.id}`
                : match.params.type === 'em'
                ? `/dashboard/em-view-details/${match.params.id}`
                : `/dashboard/rm-view-details/${match.params.id}`
            }
            onClick={() => {
              setSuccessModal(false);
            }}
            className="btn btn-primary mb-4"
          >
            {match.params.type === 'pm'
              ? localization.viewPMTickets
              : match.params.type === 'em'
              ? localization.viewEMTickets
              : localization.viewRMTickets}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default Mrf;
